import tracker from '@tcc/analytics';
import { sessionRandomId } from './loginAnalytics';

export function registrationSuccess(firstName, lastName, email) {
  tracker.segmentio.identifyUser({
    'randomId': sessionRandomId,
    'first_name': firstName,
    'last_name': lastName,
    'email': email
  });
}
